import { type AppLocale } from 'app-shared/types';

// Each language is written in itself, never translated, so people can find
// their own language whatever language the app is currently in.
export const LOCALE_NATIVE_NAMES: Record<AppLocale, string> = {
  en: 'English',
  fr: 'Français',
};
